var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGibAlt4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.613 88.7324C162.422 110.882 171.207 119.066 167.926 147.329C163.996 181.106 130.696 191.16 130.696 191.16C130.696 191.16 111.037 197.179 84.1945 194.146C57.3523 191.112 44.7611 174.982 44.7611 174.982C25.7503 153.463 33.6103 100.169 33.6103 100.169C35.7088 78.7549 43.5115 51.9699 43.5115 51.9699C52.8118 22.9052 69.9054 13.1661 69.9054 13.1661C69.9054 13.1661 81.5331 3.11221 104.941 5.31568C104.941 5.31568 133.529 6.72742 147.513 29.8208C147.513 29.8208 157.567 44.5774 154.896 66.9745C154.896 66.9745 154.553 80.8534 156.623 88.742L156.613 88.7324Z",
    fill: "#FFE26C",
    stroke: "#18181B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.782 79.7275C112.782 85.3936 107.612 89.9913 101.231 89.9913C94.8495 89.9913 89.6794 85.3936 89.6794 79.7275",
    stroke: "#18181B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.614 73.1919C128.172 73.1919 133.489 67.8753 133.489 61.3169C133.489 54.7585 128.172 49.4419 121.614 49.4419C115.056 49.4419 109.739 54.7585 109.739 61.3169C109.739 67.8753 115.056 73.1919 121.614 73.1919Z",
    fill: "#18181B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.075 59.8284C123.129 58.2897 124.419 57.0856 125.955 57.1394C127.493 57.1932 128.695 58.4845 128.642 60.0233C128.588 61.562 127.298 62.7661 125.761 62.7123C124.225 62.6581 123.021 61.3672 123.075 59.8284Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9141 73.1919C84.4724 73.1919 89.7891 67.8753 89.7891 61.3169C89.7891 54.7585 84.4724 49.4419 77.9141 49.4419C71.3557 49.4419 66.0391 54.7585 66.0391 61.3169C66.0391 67.8753 71.3557 73.1919 77.9141 73.1919Z",
    fill: "#18181B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3751 59.8284C79.4287 58.2897 80.7189 57.0856 82.2553 57.1394C83.7927 57.1932 84.9954 58.4845 84.9418 60.0233C84.8882 61.562 83.5985 62.7661 82.0611 62.7123C80.5247 62.6581 79.3215 61.3672 79.3751 59.8284Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGibAlt4);
export default __webpack_public_path__ + "static/media/gib-alt4.9abf069ca1df91648ca2df816083c928.svg";
export { ForwardRef as ReactComponent };